import { Label, Stack, Text, Dropdown, MessageBar, PrimaryButton, Spinner, MessageBarType } from "@fluentui/react"
import React, { useState, useEffect } from 'react'
import { onLoadXa } from "../../Containers/ViTriHanhChinh";
import { useSelector, useDispatch } from 'react-redux';
import Type from "../../Redux/Type";
import { onLoadDanhMucBangGia, onLoadDMDieuKien, onLoadBangGia } from "../../Containers/PriceTable";
const PriceFilterContainer = () => {
    const dispatch = useDispatch();
    const {
        arrayHuyen, listPrice,
        arrayXa, arrayLoaiDat, loadingSearch,
        arrayDuong, arrayViTri, arrayDoan
    } = useSelector(state => state.priceTableTerm);

    const [huyenChosen, setHuyenChosen] = useState(null);
    const [xaChosen, setXaChosen] = useState(null);
    const [duongChosen, setDuongChosen] = useState(null);
    const [doanChosen, setDoanChosen] = useState(null);
    const [viTriChosen, setViTriChosen] = useState(null);
    const [loaiDatChosen, setLoaiDatChosen] = useState(null);

    const [errorMessage, setErrorMessage] = useState('');
    const onChangeHuyen = (_, option) => {
        let huyen = { key: option.key, text: option.text }
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'duongSelected', value: null });
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'doanSelected', value: null });
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'huyenSelected', value: huyen });
        setHuyenChosen(huyen)
        onLoadDMDieuKien(1, option.key,'', 'arrayDuong')

    }
    const onChangeDuong = (_, option) => {
        let duong = { key: option.key, text: option.text }
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'doanSelected', value: null });
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'duongSelected', value: duong });
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loaiDatSelected', value: null });
        setDuongChosen(duong)
        onLoadDMDieuKien(2, option.key,huyenChosen.key, 'arrayDoan')
        onLoadDMDieuKien(5, option.key,'', 'arrayLoaiDat')
    }
    const onChangeDoan = (_, option) => {
        let valueSelect = { key: option.key, text: option.text }
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loaiDatSelected', value: null });
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'doanSelected', value: valueSelect });
        setDoanChosen(valueSelect)
        onLoadDMDieuKien(4, option.key,'', 'arrayLoaiDat')
    }
    const onChangeViTri = (_, option) => {
        let valueSelect = { key: option.key, text: option.text }
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'viTriSelected', value: valueSelect });
        setDoanChosen(valueSelect)
    }
    const onChangeLoaiDat = (_, option) => {
        let valueSelect = { key: option.key, text: option.text }
        dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loaiDatSelected', value: valueSelect });
        setLoaiDatChosen(valueSelect)
    }
    const onSearchPress = () => {
        setErrorMessage(null)
        if (!doanChosen || !duongChosen || !huyenChosen)
            return setErrorMessage('Vui lòng chọn đủ thông tin !')
        onLoadBangGia(huyenChosen.key, 0, 0, duongChosen.key, doanChosen.text)
    }
    useEffect(() => {
        // onLoadDanhMucBangGia(0, 'arrayHuyen')
        onLoadDanhMucBangGia(0, 'arrayHuyen')
        // onLoadDanhMucBangGia(1, 'arrayXa')
        onLoadDanhMucBangGia(2, 'arrayLoaiDat')
        onLoadDanhMucBangGia(3, 'arrayDuong')
        onLoadDanhMucBangGia(4, 'arrayViTri')
        onLoadDanhMucBangGia(5, 'arrayDoan')
    }, [])
    useEffect(() => {
        if (listPrice.length > 0) {
           // dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'showResult', value: true });
        }
        // else {
        //     setErrorMessage('Địa điểm chọn không có thông tin !')
        // }
    }, [listPrice])
    return (
        <div className='modal-content-container'>
            <div className='animated-panel position-relative'>
                <Text variant='xLarge' className='title'>Thông tin giá đất năm 2022</Text>
                <Stack tokens={{ childrenGap: 10 }} style={{ flex: 1 }}>
                    <Stack tokens={{ childrenGap: 10 }}>
                        <div style={styles.subTitleRow}>
                            <Label required={true} styles={styles.labelTitle}>Bộ lọc</Label>
                        </div>
                        <Dropdown
                            placeholder="Huyện/Thị xã/Thành phố"
                            options={arrayHuyen}
                            styles={styles.dropdownMenu}
                            selectedKey={huyenChosen ? huyenChosen.key : null}
                            onChange={onChangeHuyen}

                        />
                        {/* <Dropdown
                    placeholder="Xã/Phường/Thị trấn"
                    options={arrHuyen.filter(e => e.key === huyenChosen.key)[0]['arrXa']}
                    selectedKey={wardSelected && wardSelected.key}
                    onChange={onWardChange}
                    styles={styles.dropdownMenu}
                    disabled={modeSearch === 'byPosition' || loadingSearch || loadingLoginEnter}
                /> */}
                        <Dropdown
                            placeholder="Danh mục đường"
                            options={arrayDuong}
                            styles={styles.dropdownMenu}
                            selectedKey={duongChosen ? duongChosen.key : null}
                            onChange={onChangeDuong}
                            disabled={!huyenChosen}
                        />
                        <Dropdown
                            placeholder="Đoạn đường"
                            options={arrayDoan}
                            styles={styles.dropdownMenu}
                            selectedKey={doanChosen ? doanChosen.key : null}
                            onChange={onChangeDoan}
                            disabled={!huyenChosen || !duongChosen}
                        />
                        {/* <Dropdown
                            placeholder="Vị trí"
                            options={arrayViTri}
                            styles={styles.dropdownMenu}
                            selectedKey={viTriChosen ? viTriChosen.key : null}
                            onChange={onChangeViTri}
                        />
                          <Dropdown
                            placeholder="Loại đất"
                            options={arrayLoaiDat}
                            styles={styles.dropdownMenu}
                            selectedKey={loaiDatChosen? loaiDatChosen.key : null}
                            onChange={onChangeLoaiDat}
                        /> */}
                    </Stack>

                    <Stack style={{}}>
                        {errorMessage ?
                            <div style={{ marginTop: 5, marginBottom: 5 }}>
                                <MessageBar
                                    messageBarType={MessageBarType.severeWarning}
                                    isMultiline={true}
                                >
                                    {errorMessage}
                                </MessageBar>
                            </div>
                            : null
                        }

                        <PrimaryButton
                            styles={{ root: { marginTop: 20 } }}
                            onClick={onSearchPress}
                            disabled={loadingSearch}
                            text='Tìm'
                        />
                        <br />

                        <Spinner
                            label="Vui lòng đợi trong giây lát..."
                            labelPosition="right"
                            hidden={!loadingSearch}
                        />
                    </Stack>
                </Stack>
            </div>
        </div>
    )
}

export default PriceFilterContainer
const styles = {
    subTitleRow: {
        height: 30,
        marginTop: 2,
        display: 'flex',
        alignItems: 'flex-end'
    },
    labelTitle: {
        root: {
            textAlign: 'left'
        }
    },
    chosenGroup: {
        label: {
            textAlign: 'left'
        },
        root: {
            marginBottom: -5
        }
    },
    searchRoot: {
        root: {
            width: '100%'
        }
    },
    dropdownMenu: {
        root: {
            marginTop: 7,
        },
        title: {
            textAlign: 'left'
        },
        errorMessage: {
            textAlign: 'left'
        }
    },
    helpimg1: {
        width: '100%',
        objectFit: 'cover',
        height: 200,
    },
    textTooltip: {
        fontSize: 16, textAlign: 'center'
    },
    tooltipImg: { textAlign: 'center', marginTop: 10 }
};
